import React, { useState } from 'react'
import Fade from '@mui/material/Fade'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'

import { Icons } from './Icons'
import LockIcon from '../assets/icons/candado.svg'

export const CardInfo = (props) => {
  const { vod, isHome, pay, isUnlocked, showSeason, useImageCDN, isShort, preferredPlan } = props

  const [isVideoShown, setIsVideoShown] = useState(false)

  let timeoutId = null

  const handleMouseHover = () => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => { setIsVideoShown(true) }, 1000)
  }

  const handleMouseLeave = () => {
    clearTimeout(timeoutId)
    setIsVideoShown(false)
  }

  let link
  switch (vod.type) {
    case 'Serie':
      link = `/serie/${vod._id}`
      break;
    case 'Live':
      link = `/player/live/${vod._id}`
      break;
    case 'Event':
      link = `/evento/${vod._id}`
      break;
    case 'Vod':
      if (vod?.serie?.isShort || isShort) {
        link = `/player/shorts/${vod._id}`
      } else {
        link = `/player/vod/${vod._id}`
      }
      break;
    case 'ContentCollection':
      link = `/collection/${vod._id}`
      break;
    default:
      if (vod?.serie?.isShort || isShort) {
        link = `/player/shorts/${vod._id}`
      } else {
        link = `/player/vod/${vod._id}`
      }
      break;
  }

  return (
    <Link 
      to={
        !isUnlocked && pay 
          ? {
              pathname: '/planes',
              search: preferredPlan ? `?preferredPlan=${preferredPlan}` : ''
            }
          : link
      }
    >
      <article
        className={classNames({
          'articleItemBox whitVisibleTitle': true,
          'cwCard': isHome
        })}
        onMouseEnter={() => handleMouseHover()}
        onMouseLeave={() => handleMouseLeave()}
      >
        <figure className='ratioImgBox ratioThumb'>
          {!isUnlocked && pay && <Icons path={LockIcon} className='lockIcon' />}
          <img
            src={!isEmpty(vod.imagesSite.thumbnail)
              ? useImageCDN
                ? vod.imagesSite.thumbnail.replace('https://api-megago.megamedia.cl', 'https://megago.cdn.mdstrm.com')
                : vod.imagesSite.thumbnail
              : 'https://images2-mega.cdn.mdstrm.com/ott/placeholders-imgs/placeholder-thumbnail.jpg'
            }
            alt=''
          />
          {isVideoShown && (
            <Fade in={isVideoShown} timeout={600} style={{ transitionDelay: '500ms' }}>
              <video id={`video_cardInfo_${vod.idMedia}`} autoPlay preload='auto' loop='loop' muted>
                <source src={`https://mdstrm.com/video/${vod.idMedia}/preview.mp4`} type='video/mp4' />
              </video>
            </Fade>
          )}
        </figure>
        <header>
          <h3>{
            vod.serie?.seasons.length > 0 ?
              isHome
                ? `${showSeason ? `T${vod.season?.order || 1}:` : ''}${(vod.serie?.seasons[0]?.vods?.length ?? 0) > 0 ? `E${Number(vod.order) + 1} ` : ''}`
                : `${showSeason ? `T${vod.season?.order || 1}:` : ''}E${Number(vod.order) + 1}`
            : vod.title
          }</h3>
          <p>
            {
              vod.serie?.seasons.length > 0 ?
                isHome
                ? vod.serie !== null
                  ? vod.serie.title
                  : vod.event.title
                : vod.title
              :
              vod.resume
            }
          </p>
          <div className='continueBar' style={{ 'width': '100%', 'display': vod.position ? 'block' : 'none' }}>
            <span style={{
              'width': `${(isNaN((vod.position / vod.duration)) ? 0 : (vod.position / vod.duration) * 100)}%`
            }} />
          </div>
        </header>
      </article>
    </Link>
  )
}